import { render, staticRenderFns } from "./grantNamedRegionsCards.vue?vue&type=template&id=a633331e&scoped=true&"
import script from "./grantNamedRegionsCards.vue?vue&type=script&lang=js&"
export * from "./grantNamedRegionsCards.vue?vue&type=script&lang=js&"
import style0 from "./grantNamedRegionsCards.vue?vue&type=style&index=0&id=a633331e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a633331e",
  null
  
)

export default component.exports